
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SERVICES } from '../data';

export const ServicesListing: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-white pb-0 relative overflow-hidden">
      {/* Floating Elements */}
      <div className="absolute top-[800px] -right-40 w-96 h-96 border-[40px] border-brand-accent/5 rounded-full animate-spin-slow pointer-events-none"></div>
      <div className="absolute top-[1500px] -left-40 w-[600px] h-[600px] bg-brand-deep/5 blob-bg rounded-full animate-float pointer-events-none"></div>

      {/* Cinematic Hero */}
      <section className="relative h-[450px] md:h-[650px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?q=80&w=2000&auto=format&fit=crop" 
            className="w-full h-full object-cover brightness-[0.4]"
            alt="Services Hero"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/60"></div>
        </div>
        
        <div className="relative z-10 text-center px-6 animate-fade-in">
          <div className="inline-block bg-brand-accent text-white px-5 py-2 rounded-lg text-[9px] md:text-[10px] font-black uppercase tracking-[0.3em] mb-6 md:mb-8 shadow-xl">
            Pieredze un Kvalitāte
          </div>

          <h1 className="text-4xl md:text-7xl font-black text-white tracking-tighter leading-none uppercase select-none">
            Mūsu <span className="text-brand-accent">Pakalpojumi</span>
          </h1>

          <div className="w-20 md:w-32 h-2 md:h-2.5 bg-brand-accent mx-auto mt-4 md:mt-6 rounded-full shadow-[0_4px_15px_rgba(255,130,46,0.6)]"></div>
        </div>
      </section>

      {/* Content Wrapper */}
      <div className="relative pt-12 md:pt-24 bg-white">
        {/* Services Grid - Base 1 column */}
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 relative z-20 mb-16 md:mb-32">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
            {SERVICES.map((service) => (
              <div 
                key={service.id} 
                onClick={() => navigate(`/pakalpojumi/${service.slug}`)}
                className="group bg-white rounded-lg overflow-hidden shadow-[0_30px_80px_-15px_rgba(5,7,60,0.1)] hover:shadow-[0_50px_100px_-15px_rgba(5,7,60,0.2)] transition-all duration-700 cursor-pointer flex flex-col h-full border border-gray-100 transform hover:-translate-y-2 text-left"
              >
                <div className="h-56 md:h-72 overflow-hidden relative">
                  <img 
                    src={service.image} 
                    alt={service.title} 
                    className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-brand-deep/30 group-hover:bg-brand-deep/10 transition-colors duration-500"></div>
                  <div className="absolute top-4 left-4 md:top-6 md:left-6 w-12 h-12 md:w-14 md:h-14 bg-white rounded-lg flex items-center justify-center text-brand-accent text-xl md:text-2xl shadow-2xl transform -rotate-6 group-hover:rotate-0 transition-transform">
                    <i className={service.icon}></i>
                  </div>
                </div>

                <div className="p-6 md:p-10 flex flex-col flex-grow">
                  <h3 className="text-xl md:text-2xl font-black text-brand-deep leading-tight tracking-tighter mb-4 group-hover:text-brand-accent transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-brand-deep/60 leading-relaxed font-medium mb-6 md:mb-8 flex-grow text-xs md:text-sm">
                    {service.shortDescription}
                  </p>
                  <div className="pt-5 md:pt-6 border-t border-gray-50 flex items-center justify-between">
                    <span className="text-[9px] md:text-[10px] font-black uppercase tracking-widest text-brand-accent flex items-center gap-3">
                      Uzzināt vairāk <i className="fas fa-arrow-right text-[9px]"></i>
                    </span>
                    <div className="text-[8px] font-black text-brand-deep/20 uppercase tracking-widest">Premium</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Value Proposition Section */}
        <section className="bg-brand-surface py-16 md:py-32 relative overflow-hidden border-y border-gray-100 clip-circle-top">
          <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 relative z-10">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-16 items-center">
              <div className="space-y-6 md:space-y-8 text-center lg:text-left">
                <div className="inline-block bg-orange-50 text-brand-accent px-4 py-1.5 rounded-full text-[9px] font-black uppercase tracking-[0.3em]">Mūsu solījums</div>
                <h2 className="text-3xl md:text-6xl font-black text-brand-deep tracking-tighter leading-tight">Kāpēc izvēlēties <br className="hidden md:block" /><span className="text-brand-accent">LEC Travel?</span></h2>
                <div className="space-y-6 md:space-y-8 pt-2 text-left">
                  <div className="flex gap-4 md:gap-6 group">
                    <div className="w-12 h-12 md:w-16 md:h-16 bg-white rounded-lg flex items-center justify-center text-brand-accent text-lg md:text-2xl shadow-lg flex-shrink-0"><i className="fas fa-gem"></i></div>
                    <div>
                      <h4 className="text-base md:text-xl font-black text-brand-deep mb-1.5 tracking-tight">Ekskluzīvi maršruti</h4>
                      <p className="text-xs md:text-sm text-brand-deep/60 font-medium leading-relaxed">Piedāvājam galamērķus un pieredzes, ko neatradīsiet standarta katalogos.</p>
                    </div>
                  </div>
                  <div className="flex gap-4 md:gap-6 group">
                    <div className="w-12 h-12 md:w-16 md:h-16 bg-white rounded-lg flex items-center justify-center text-brand-accent text-lg md:text-2xl shadow-lg flex-shrink-0"><i className="fas fa-headset"></i></div>
                    <div>
                      <h4 className="text-base md:text-xl font-black text-brand-deep mb-1.5 tracking-tight">24/7 Krīzes atbalsts</h4>
                      <p className="text-xs md:text-sm text-brand-deep/60 font-medium leading-relaxed">Mēs esam viena zvana attālumā, lai operatīvi risinātu jebkuru situāciju.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="relative mt-4 lg:mt-0 max-w-[320px] md:max-w-[450px] lg:max-w-none mx-auto w-full">
                 <div className="absolute -top-10 -right-10 w-40 h-40 bg-brand-accent/20 rounded-full blur-[80px]"></div>
                 <div className="relative rounded-2xl md:rounded-3xl overflow-hidden shadow-2xl md:rotate-3 border-[8px] md:border-[15px] border-white">
                    <img src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=1200&auto=format&fit=crop" className="w-full aspect-[4/5] object-cover" alt="Expert Support" />
                 </div>
              </div>
            </div>
          </div>
        </section>

        {/* Impact Visual Section */}
        <section className="py-20 md:py-24 bg-brand-deep relative overflow-hidden">
          <div className="absolute inset-0">
             <img 
               src="https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?q=80&w=2400&auto=format&fit=crop" 
               className="w-full h-full object-cover opacity-20 grayscale"
               alt="Inspiring landscape"
             />
             <div className="absolute inset-0 bg-gradient-to-r from-brand-deep via-brand-deep/80 to-transparent"></div>
          </div>
          
          <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 relative z-10 flex flex-col lg:flex-row items-center gap-12 lg:gap-32">
             <div className="flex-1 text-left">
                <h2 className="text-3xl md:text-6xl font-black text-white tracking-tighter leading-tight mb-6">
                  Pievienojies mūsu <br className="hidden md:block" />
                  <span className="text-brand-accent">ceļotāju kopienai.</span>
                </h2>
                <p className="text-white/60 text-lg md:text-xl font-medium leading-relaxed mb-10">
                  Pasaule ir pārāk skaista, lai to redzētu tikai caur ekrānu. Ļauj mums būt tavam gidam uz vietām, kuras vēl neesi iedomāties.
                </p>
                <div className="flex flex-wrap gap-6 items-center">
                   <div className="flex -space-x-4">
                     {[1,2,3,4,5].map(i => (
                       <img key={i} src={`https://i.pravatar.cc/100?u=user${i}`} className="w-12 h-12 rounded-lg border-2 md:border-4 border-brand-deep object-cover shadow-2xl" alt="Happy traveler" />
                     ))}
                   </div>
                   <div className="text-white/40 text-[9px] md:text-xs font-black uppercase tracking-widest text-left">
                     Vairāk nekā <span className="text-white">15,000</span> stāstu
                   </div>
                </div>
             </div>
             
             <div className="flex-1 w-full max-w-lg">
                <div className="bg-white p-8 md:p-12 rounded-xl shadow-2xl border border-white/20 transform lg:rotate-2 text-left">
                   <div className="text-brand-accent text-4xl md:text-5xl mb-6 md:mb-8"><i className="fas fa-paper-plane"></i></div>
                   <h3 className="text-2xl md:text-3xl font-black text-brand-deep mb-4 tracking-tight">Gatavi plānot?</h3>
                   <p className="text-brand-deep/60 font-bold mb-8 md:mb-10 text-sm">Mūsu konsultācija ir pirmais solis uz tavu labāko atvaļinājumu.</p>
                   <button 
                     onClick={() => navigate('/kontakti')}
                     className="w-full bg-brand-deep text-white py-5 md:py-6 rounded-lg font-black text-xs uppercase tracking-[0.3em] hover:bg-brand-accent transition-all shadow-xl shadow-brand-deep/20 active:scale-95"
                   >
                     Sazināties ar ekspertu
                   </button>
                </div>
             </div>
          </div>
        </section>
      </div>
    </div>
  );
};
